
import {
  Store,
  Package,
  ClipboardList,
  DollarSign,
  ChartBar,
  Users,
  Settings,
  ShoppingBag,
  Bell
} from "lucide-react";
import { NavigationConfig } from "../types";

export const vendorNavigation: NavigationConfig[] = [
  { name: "Dashboard", href: "/vendor", icon: Store },
  { 
    name: "Products", 
    icon: Package,
    children: [
      { name: "All Products", href: "/vendor/products", icon: ShoppingBag },
      { name: "Add Product", href: "/vendor/products/add", icon: Package },
    ]
  },
  { name: "Orders", href: "/vendor/orders", icon: ClipboardList },
  { name: "Customers", href: "/vendor/customers", icon: Users },
  { 
    name: "Analytics", 
    icon: ChartBar,
    children: [
      { name: "Sales", href: "/vendor/analytics/sales", icon: DollarSign },
      { name: "Performance", href: "/vendor/analytics/performance", icon: ChartBar },
    ]
  },
  { name: "Notifications", href: "/vendor/notifications", icon: Bell },
  { name: "Settings", href: "/vendor/settings", icon: Settings },
];
